import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const BubbleRoundFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.7337 14.4114C8.99966 14.2159 9.27652 14.0156 9.56016 13.8103C12.4323 11.7322 16.0004 9.15038 16.0004 5.95479C16.0004 1.86388 12.0004 0.500244 8.00037 0.500244C4.00037 0.500244 0.000366211 1.86388 0.000366211 5.95479C0.000366211 9.81819 3.56783 11.2492 7.3337 11.3964V15.5002C7.73878 15.155 8.21557 14.7923 8.7337 14.4114ZM11.3306 6.69878H4.66565V5.29878H11.3306V6.69878Z", fill: "var(--magritte-ui-icon-color)" }) }) }) }));
const BubbleRoundFilledSize16 = hoc(forwardRef(BubbleRoundFilledSize16Component), 'BubbleRoundFilledSize16');

export { BubbleRoundFilledSize16 as default };
//# sourceMappingURL=BubbleRoundFilledSize16.js.map
